// extracted by mini-css-extract-plugin
module.exports = {"accordion":"v_C","active":"v_cb","icon":"v_cc"};